<influencer-module-container [title]="'INFLUENCER.overview.popular_topics.title' | translate"
    [tooltip] = "'info_box.influencer.popular_topics' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="301"
    [height]="'265px'">

    <div class="chart-area">
        <achoo-pie-chart *ngIf="!hasNoData && !isFetchingData"
            [chartData]="drawnData"
            [height]="265"
            [legend]="legend"
            [chartConfig]="chartConfig"
            [overridenSeriesConfig]="overridenSeriesConfig"
            [overridenPiePlotOptions]="overridenPiePlotOptions"
            [applyResponsive]="false">
        </achoo-pie-chart>

        <achoo-pie-chart *ngIf="hasNoData || isFetchingData"
            [chartData]="placeholderData"
            [height]="265"
            [legend]="legend"
            [chartConfig]="chartConfig"
            [overridenSeriesConfig]="overridenSeriesConfig"
            [overridenPiePlotOptions]="overridenPiePlotOptions"
            [applyResponsive]="false">
        </achoo-pie-chart>
    </div>

</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/popular-topics/popular-topics.component.html